import platformInfo from "platform";
import { setSessionCookie } from "./sessions";
import uuid from "uuid-random";
import { readCookie, setLongTermCookie } from "./cookies";

const VISITOR_KEY = "_gsvid";

const facetsMap = {
  title: "title",
  path: "path",
  location: "lct",
  sessionID: "sid",
  ID: "id",
  browser: "bst",
  browserVersion: "bsv",
  deviceType: "dvi",
  OSArchitecture: "osa",
  OSType: "ost",
  OSVersion: "osv",
  screenResolution: "res",
};

const Facets = function () {
  const setTitle = (title) => {
    this.title = title;
    return this;
  };

  const setPath = (path) => {
    this.path = path;
    return this;
  };

  const setLocation = (location) => {
    this.location = location;
    return this;
  };

  const setSessionID = (sessionID) => {
    this.sessionID = sessionID;
    return this;
  };

  const setID = (id) => {
    this.id = id;
    return this;
  };

  const setBrowser = (browser) => {
    this.browser = browser;
    return this;
  };

  const setBrowserVersion = (browserVersion) => {
    this.browserVersion = browserVersion;
    return this;
  };

  const setDeviceType = (deviceType) => {
    this.deviceType = deviceType;
    return this;
  };

  const setOSArchitecture = (OSArchitecture) => {
    this.OSArchitecture = OSArchitecture;
    return this;
  };

  const setOSType = (OSType) => {
    this.OSType = OSType;
    return this;
  };

  const setOSVersion = (OSVersion) => {
    this.OSVersion = OSVersion;
    return this;
  };

  const setScreenResolution = (screenWidth, screenHeight) => {
    this.screenResolution =
      screenWidth.toString() + "x" + screenHeight.toString();
    return this;
  };

  const build = () => {
    let commonFacets = new Object();
    commonFacets[facetsMap.title] = this.title;
    commonFacets[facetsMap.path] = this.path;
    commonFacets[facetsMap.location] = this.location;
    commonFacets[facetsMap.sessionID] = this.sessionID;
    commonFacets[facetsMap.ID] = this.id;
    commonFacets[facetsMap.browser] = this.browser;
    commonFacets[facetsMap.browserVersion] = this.browserVersion;
    commonFacets[facetsMap.deviceType] = this.deviceType;
    commonFacets[facetsMap.OSArchitecture] = this.OSArchitecture;
    commonFacets[facetsMap.OSType] = this.OSType;
    commonFacets[facetsMap.OSVersion] = this.OSVersion;
    commonFacets[facetsMap.screenResolution] = this.screenResolution;
    return commonFacets;
  };

  return Object.freeze({
    setTitle,
    setPath,
    setLocation,
    setSessionID,
    setID,
    setBrowser,
    setBrowserVersion,
    setDeviceType,
    setOSArchitecture,
    setOSType,
    setOSVersion,
    setScreenResolution,
    build,
  });
};

const setPlatformFacets = (clientOptions) => {
  clientOptions.facets.setBrowser(platformInfo.name);
  clientOptions.facets.setBrowserVersion(platformInfo.version);
  clientOptions.facets.setDeviceType(platformInfo.product);
  if (platformInfo.os.architecture) {
    clientOptions.facets.setOSArchitecture(
      platformInfo.os.architecture.toString()
    );
  }
  clientOptions.facets.setOSType(platformInfo.os.family);
  clientOptions.facets.setOSVersion(platformInfo.os.version);
};

const setCommonFacets = (clientOptions) => {
  clientOptions.facets.setTitle(document.title);
  clientOptions.facets.setPath(document.location.pathname);
  clientOptions.facets.setLocation(document.URL.split("#")[0]);

  if (navigator.cookieEnabled) {
    clientOptions.facets.setSessionID(setSessionCookie(30));
    clientOptions.facets.setID(setVisitorId());
  }

  var screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  var screenHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  clientOptions.facets.setScreenResolution(screenWidth, screenHeight);
};

const setVisitorId = () => {
  let visitorID = readCookie(VISITOR_KEY);
  if (visitorID === null) {
    visitorID = uuid();
  }
  setLongTermCookie(VISITOR_KEY, visitorID);
  return visitorID;
};

export { facetsMap, Facets, setPlatformFacets, setCommonFacets };
